import { JSX } from "react";
import { Attestation } from "./models/attestation";
import { AttestationRow } from "./models/attestationRow";
import QdpAttestorDetailsPanel from "./QdpAttestorDetailsPanel";
import { FlyoutLink } from "@app/shared/Flyouts";

interface QdpAttestationRowProps {
  row: AttestationRow;
  rowDepth: string;
  index?: number;
  sourceId?: string;
}

function dashed(value: string) {
  return value || "--";
}

function dashedLink(value: string, attestation: Attestation) {
  if (value && attestation && attestation.AttestationId) {
    return (
      <FlyoutLink
        classNames="text-info fw-normal p-0"
        content={{
          body: openAttestationPanel(attestation),
          title: "Details",
        }}
        size="40"
        testId="qdp-attestation-row__flyout"
      >
        {value}
      </FlyoutLink>
    );
  }

  return dashed(value);
}

function openAttestationPanel(attestation: Attestation) {
  return (
    <QdpAttestorDetailsPanel attestation={attestation} />
  );
}


export default function QdpAttestationRow(props: QdpAttestationRowProps): JSX.Element {

  const targetId:string = "a" + crypto.randomUUID();

  return (
    <>
      <li className="list-group-item bordered" data-bs-toggle="collapse" data-bs-target={"#"+targetId}>
        <div className={`col-4 evidence-depth-${props.rowDepth}`}>
          {props.row.AdditionalProperties ? <span className="expandable"> {dashed(props.row.Value)}</span> :
            <>{dashed(props.row.Value)}</>}
        </div>
        < div className="col-4" >
          {dashed(props.row.RecordStatus)}
        </div>
        <div className="col-4">
          {dashedLink(props.row.VerificationReference, props.row.Attestation)}
        </div>
      </li>
      <div className="collapse" id={targetId}>
        {props.row.AdditionalProperties && Object.keys(props.row.AdditionalProperties).map((key, index) => (
          <QdpAttestationRow row={{ RecordStatus: props.row.AdditionalProperties[key], Value: key }} rowDepth={(parseInt(props.rowDepth) + 2).toString()} key={index} />))
        }
      </div>
    </>
  );
}

